import React from 'react';

class Hamburger extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.props.open? this.props.open: false,
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.open !== this.state.open){
          this.setState({open:nextProps.open});
        }
      }


    handleClick() {
        //TODO rework this pursuant to the issue reaised by 
        // https://www.youtube.com/watch?v=l6nmysZKHFU
        this.setState({ open: !this.state.open });
    }

    handleLinkClick() {
        this.setState({ menuOpen: false });
    }

    render() {
        //const Hamburger = () => (
        return (
            <button onClick={this.props.onClick ? this.props.onClick: 
                ()=> {this.handleClick();}} className="header__btn hamburger">
                <span className="header__btn-line"></span>
                <span className="header__btn-line"></span>
                <span className="header__btn-line"></span>
            </button>
        )
    }
}

export default Hamburger
